import React from 'react';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { Button } from './component_button';
import { showAppError } from '../utils/util_helpers';


export function StripePaymentForm(props) {
    const {
        onStripeLoading = (isLoading = false) => {},
        onResult = (result = {}) => {}
    } = props;

    const stripe = useStripe();
    const stripeElements = useElements();

    const [isSubmitting, setSubmitting] = React.useState(false);

    return(
        <>
            <PaymentElement />

            <Button
                style={{ marginTop: 16 }}
                text={'Submit'}
                locked={!stripe || !stripeElements}
                isLoading={isSubmitting}
                onPress={() => {
                    setSubmitting(true);
                    onStripeLoading(true);
                    stripe.confirmSetup({ elements: stripeElements, redirect: 'if_required' })
                        .then((result) => onResult(result))
                        .catch((error) => showAppError(error.message))
                        .finally(() => {
                            setTimeout(() => {
                                setSubmitting(false);
                                onStripeLoading(false);
                            }, 1000);
                        });
                }}
            />
        </>
    );
}
